import { PropsWithChildren } from "react";
import SVGClose from "../../icons/Close.svg?react";
import styles from "./Alert.module.css";
import Icon from "./Icon";

type Props = PropsWithChildren<{
  onDismiss?: () => void;
}>;

const Alert = ({ onDismiss, children }: Props) => (
  <div className={styles.alert}>
    {children}
    {onDismiss && (
      <button
        type="button"
        className={styles.dismissButton}
        onClick={onDismiss}
      >
        <Icon glyph={SVGClose} className={styles.icon} />
      </button>
    )}
  </div>
);

export default Alert;
